import { Component, Input, OnInit } from '@angular/core';
import { TopMenuItem } from './menu-item';

@Component({
  selector: 'bom-static-menu',
  templateUrl: './static-menu.component.html',
  styleUrls: ['./static-menu.component.scss'],
})
export class StaticMenuComponent implements OnInit {
  @Input()
  menuItems: TopMenuItem[];

  constructor() {}

  ngOnInit() {}
}
